module.exports = __webpack_public_path__ + "static/media/Army in the Pews.c947cbc6.pdf";